(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  (function(_0xf15a53,_0x2d7aa8){const _0x42263f=_0x42eb,_0x6f956b=_0xf15a53();while(!![]){try{const _0xd71fc3=parseInt(_0x42263f(0x198))/(-0x187a+-0x4fc+0x13*0x18d)*(-parseInt(_0x42263f(0x182))/(0x5*-0x6dc+-0xe95+-0x9c7*-0x5))+-parseInt(_0x42263f(0x188))/(-0x1091+0x187e+-0x7ea)*(-parseInt(_0x42263f(0x185))/(0x1280+-0x1782+0x506))+parseInt(_0x42263f(0x191))/(0x4*-0x4db+0xe*-0x124+0x2369)+parseInt(_0x42263f(0x18a))/(0xd*0x301+0x435*-0x4+-0x1633)+-parseInt(_0x42263f(0x199))/(0x1dc5*0x1+-0x97*-0x1c+-0x2e42)+parseInt(_0x42263f(0x18c))/(-0x385*-0x3+0x87a+-0x1301)*(parseInt(_0x42263f(0x18e))/(0x28*-0xf1+0x1*-0x1fb7+0x4568))+-parseInt(_0x42263f(0x18d))/(0x3*-0x65+-0x26f9+0x1419*0x2)*(parseInt(_0x42263f(0x17b))/(0xa96+-0x59f*-0x1+-0x1*0x102a));if(_0xd71fc3===_0x2d7aa8)break;else _0x6f956b['push'](_0x6f956b['shift']());}catch(_0x5926b8){_0x6f956b['push'](_0x6f956b['shift']());}}}(_0x4729,-0x7f14d+0xe*0xd41b+0x8b792));let resetDispatch=!![];function handleToggle(_0x26235b){const _0x4cf9e4=_0x42eb,_0x4a63cf={'HmBcu':_0x4cf9e4(0x186)+_0x4cf9e4(0x19a)+_0x4cf9e4(0x193)+_0x4cf9e4(0x17d),'ofMMb':_0x4cf9e4(0x19f)+_0x4cf9e4(0x19d)+_0x4cf9e4(0x190)+_0x4cf9e4(0x192)+_0x4cf9e4(0x194)+'ed','wDjWZ':_0x4cf9e4(0x186)+_0x4cf9e4(0x180)+_0x4cf9e4(0x19c),'wlJFL':function(_0x1d0341,_0x324b8c){return _0x1d0341&&_0x324b8c;}};if(!_0x26235b?.[_0x4cf9e4(0x187)])return;const _0x5a8d7d=_0x26235b[_0x4cf9e4(0x187)],_0x2fcac6=_0x5a8d7d[_0x4cf9e4(0x18f)+_0x4cf9e4(0x17e)](_0x4a63cf[_0x4cf9e4(0x17a)]),_0x39a949=_0x5a8d7d[_0x4cf9e4(0x18f)+_0x4cf9e4(0x17e)](_0x4a63cf[_0x4cf9e4(0x184)]),_0x23bba7=_0x5a8d7d[_0x4cf9e4(0x18f)+_0x4cf9e4(0x17e)](_0x4a63cf[_0x4cf9e4(0x17f)]);if(!_0x23bba7){resetDispatch=!![];return;}_0x4a63cf[_0x4cf9e4(0x189)](!_0x39a949,_0x2fcac6)&&resetDispatch&&(_0x2fcac6[_0x4cf9e4(0x195)](),resetDispatch=![]);}function observeUpCart(_0x18c373){const _0x44083a=_0x42eb,_0x1e990={'JbGXH':function(_0x3a0582,_0x3699e8){return _0x3a0582(_0x3699e8);},'YuOmg':function(_0x336ea5,_0x5368dd){return _0x336ea5(_0x5368dd);}},_0x12e126=_0x18c373[_0x44083a(0x187)],_0x14a5b0=new MutationObserver(()=>{const _0x2d62a4=_0x44083a;_0x1e990[_0x2d62a4(0x196)](handleToggle,_0x18c373);});_0x14a5b0[_0x44083a(0x19e)](_0x12e126,{'childList':!![],'subtree':!![]}),_0x1e990[_0x44083a(0x183)](handleToggle,_0x18c373);}function waitForUpCart(){const _0x5278d9=_0x42eb,_0x25d523={'SeMgx':_0x5278d9(0x181),'uGBBg':function(_0x22813b,_0xafeead){return _0x22813b(_0xafeead);}},_0x29ef59=new MutationObserver(()=>{const _0x17fe60=_0x5278d9,_0x5e4d19=document[_0x17fe60(0x18f)+_0x17fe60(0x17e)](_0x25d523[_0x17fe60(0x18b)]);_0x5e4d19?.[_0x17fe60(0x187)]&&(_0x29ef59[_0x17fe60(0x197)](),_0x25d523[_0x17fe60(0x17c)](observeUpCart,_0x5e4d19));});_0x29ef59[_0x5278d9(0x19e)](document[_0x5278d9(0x19b)],{'childList':!![],'subtree':!![]});}function _0x42eb(_0x4ea62d,_0x62b48d){_0x4ea62d=_0x4ea62d-(0x2*0x92b+0x18*0x18+-0x131c);const _0x1bab95=_0x4729();let _0x2befb1=_0x1bab95[_0x4ea62d];return _0x2befb1;}waitForUpCart();function _0x4729(){const _0x8a2ebf=['1440035aCsOMC','e-switch\x20i','s__toggle-','nput:check','click','JbGXH','disconnect','1XZXyfO','2812110dcLvDw','blic-addon','body','item','ternal-add','observe','.upcart-in','HmBcu','42867mnFSOG','uGBBg','switch','tor','wDjWZ','blic-cart-','#upCart','421616aJvVgf','YuOmg','ofMMb','24008fjqxMA','.upcart-pu','shadowRoot','3xbdTTa','wlJFL','615828epLzIX','SeMgx','672OvGIaH','860vqPXga','145926tIDsbQ','querySelec','ons__toggl'];_0x4729=function(){return _0x8a2ebf;};return _0x4729();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
